import testFnc from "./components/test";
testFnc();


import accordion from "./components/accordion";
accordion();

import swipers from "./components/swipers";
swipers();

import select from "./components/select";
select();

import mask from "./components/mask";
mask();

import form from "./components/form";
form();

import range from "./components/range";
range();

import calc from "./components/calc";
calc();

import header from "./components/header";
header();

import animations from "./components/animations";
animations();